import { Button, Tooltip } from "@mui/material";
import JoinInnerIcon from "@mui/icons-material/JoinInner";
import { useTranslation } from "react-i18next";
import { K } from "./apiServiceI18n";
import {
  buildWorkbenchMappingUrl,
  saveWizardReturnContext,
} from "./apiServiceWizardSession";

/**
 * Opens workbench outbound mapping for wizard-created templates.
 * Stores return context so workbench can offer “Continue to Wizard”.
 */
export default function ApiServiceWizardMappingButton({
  translateData,
  form,
  wizardStep,
  memSnapshots,
  hasTranslate,
  disabled,
}) {
  const { t } = useTranslation();
  const canMap =
    translateData?.workflowGroup &&
    translateData?.inboundTemplate &&
    translateData?.outboundTemplate;

  if (!canMap) return null;

  const handleClick = () => {
    saveWizardReturnContext({
      step: wizardStep,
      form,
      translateData,
      memSnapshots,
      hasTranslate,
    });

    window.location.href = buildWorkbenchMappingUrl(translateData);
  };

  return (
    <Tooltip title={t(K.API_SVC_GO_TO_MAPPING)} arrow>
      <span>
        <Button
          variant="contained"
          size="small"
          startIcon={<JoinInnerIcon />}
          onClick={handleClick}
          disabled={disabled}
          sx={{ textTransform: "none" }}
        >
          {t(K.API_SVC_BTN_MAPPING)}
        </Button>
      </span>
    </Tooltip>
  );
}
